module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-z4-ccae2c6de334707262fd8e83ada13f03.svg";